<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Use Guest Pass</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">
    <div class="form-group">
      <label for="searchCustomersInput">Search Customers</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
         *ngIf="selectedGrantingCustomer === null">

      <ng-container *ngIf="hasSearchInput()">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of filteredCustomerResults()"
                (click)="selectGrantingCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

    <div class="mt-3 mb-3" *ngIf="selectedGrantingCustomer !== null">
      <p class="text-muted" *ngIf="loadingGuestPasses">Loading guest passes...</p>
      <div class="alert alert-danger" *ngIf="!loadingGuestPasses && guestPassesErrorMessage">
        {{ guestPassesErrorMessage }}
      </div>
      <ng-container *ngIf="!loadingGuestPasses && !guestPassesErrorMessage">
        <div *ngFor="let guestPass of grantingCustomerGuestPasses; let isLast = last">
          <button class="btn btn-sm btn-primary float-right"
                  [disabled]="guestPassIsUnusable(guestPass)"
                  [class.disabled]="guestPassIsUnusable(guestPass)"
                  (click)="guestPassChosenCallback(guestPass.id);activeModal.close();">
            Use
          </button>

          <p>
            <b>{{ getGuestPassSourceText(guestPass) }}</b>

            <ng-container *ngIf="guestPassMembershipIsInactive(guestPass)">
              <br>

              <span class="text-danger">
                Temporarily unavailable: membership status is
                {{ getCustomerMembershipStatusDisplay(guestPass.granting_membership_status) }}
              </span>
            </ng-container>

            <ng-container *ngIf="guestPass.ineligibility_reason">
              <br>

              <span class="text-danger">
                {{ guestPass.ineligibility_reason }}
              </span>
            </ng-container>

            <br>

            Expires:
            <b *ngIf="guestPass.expires_at_date">End of {{ dateStringFromISO8601(guestPass.expires_at_date) }}</b>
            <b *ngIf="!guestPass.expires_at_date">Never</b>

            <br>

            Usable by {{ getGuestPassEligibilityDisplay(guestPass.eligibility, orgConfigService.getLapsedGuestPassWindowMonths()) }}
            <small class="text-muted d-block"
                   *ngIf="guestPass.eligibility === GuestPassEligibility.lapsedCustomersOnly">
              The lapsed-customer window is configured under
              <a routerLink="/organization-settings" target="_blank">Organization Settings</a>.
            </small>
          </p>

          <hr *ngIf="!isLast">
        </div>

        <div class="alert alert-warning"
             *ngIf="selectedGrantingCustomer.id === customer.id">
          You are using this customer's own guest pass for their entry. This will deduct a guest pass from their
          account, even if their membership would otherwise grant them entry.
        </div>

        <ng-container *ngIf="grantingCustomerGuestPasses.length === 0">
          <p>
            The selected customer has no available guest passes.
          </p>
        </ng-container>
      </ng-container>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
  </div>

</ng-container>
